export interface CustomCode {
  enabled: boolean;
  code: string;
}

export const STOP_CUSTOM_PARAM = 'stopcustom';
